import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-no-data-box',
    templateUrl: './no-data-box.component.html',
    styleUrls: ['./no-data-box.component.scss'],
    standalone: false
})
export class NoDataBoxComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
